export default __webpack_public_path__ + "static/media/password.5201665d.svg";